import { cacheDom } from "../utils/QuerySelectors.js"
import { isInViewport } from "../utils/helpers.js"
const dom = {}
const qs = {
  video: 'data-video',
  json: 'data-video-json',
}
const qsAll = {
  sections: 'data-section-type="hero"',
}

const initVideo = (section) => {
  if(section.querySelector(`[${qs.json}]`)) {
    var video = section.querySelector(`[${qs.video}]`)
    const json = JSON.parse(section.querySelector(`[${qs.json}]`).innerHTML)

    document.addEventListener('scroll', function () {
      if(isInViewport(section) && !section.classList.contains('hero--video__inited')) {
        section.classList.add('hero--video__inited')
        if(!document.querySelector('#videojs-css')) {
          const link = document.createElement("link")
          link.rel = 'stylesheet'
          link.href = section.dataset.css
          link.id = 'videojs-css'
          document.body.append(link)

          const script = document.createElement("script")
          script.src = section.dataset.js
          script.id = 'videojs-js'
          document.body.append(script)
        }
        if(!video) {
          var videoHtml = `<video
            id="video-${json.sectionId}"
            class="hero-media video-js"`
          videoHtml += ` ${json.controls ? 'controls' : ''} `
          videoHtml += `
            muted
            autoplay
            playsinline
            loop
            preload="auto"
            data-video
            poster="${json.video.preview_image.src + '&width=1600'}"
            data-setup='{}'>`
          json.video.sources.forEach((source) => videoHtml += `<source src="${source.url}" type="${source.mime_type}"></source>`)
          videoHtml += `
                <p class="vjs-no-js">
                To view this video please enable JavaScript, and consider upgrading to a
                web browser that supports HTML5 video
              </p>
            </video>`
          section.innerHTML = videoHtml + section.innerHTML
          video = section.querySelector(`[${qs.video}]`)
        }
        if(typeof videojs != 'undefined') videojs(video.id)
      }
    }, {
      passive: true
    })
  }
}

export const setupHero = () => {
  cacheDom(dom, qs, qsAll)
  dom.sections.forEach((section) => {
    initVideo(section)
  })
}